var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9200_1641",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9200_1641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.53854 13.6667C3.20176 13.6667 2.91671 13.55 2.68337 13.3167C2.45004 13.0834 2.33337 12.7983 2.33337 12.4615V3.53854C2.33337 3.20176 2.45004 2.91671 2.68337 2.68337C2.91671 2.45004 3.20176 2.33337 3.53854 2.33337H7.74354V3.33337H3.53854C3.48721 3.33337 3.44021 3.35476 3.39754 3.39754C3.35476 3.44021 3.33337 3.48721 3.33337 3.53854V12.4615C3.33337 12.5129 3.35476 12.5599 3.39754 12.6025C3.44021 12.6453 3.48721 12.6667 3.53854 12.6667H12.4615C12.5129 12.6667 12.5599 12.6453 12.6025 12.6025C12.6453 12.5599 12.6667 12.5129 12.6667 12.4615V8.25654H13.6667V12.4615C13.6667 12.7983 13.55 13.0834 13.3167 13.3167C13.0834 13.55 12.7983 13.6667 12.4615 13.6667H3.53854ZM6.47954 10.223L5.77704 9.52054L11.9642 3.33337H9.33337V2.33337H13.6667V6.66671H12.6667V4.03587L6.47954 10.223Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.37699c4e66dc71032711829995055fc5.svg";
export { ForwardRef as ReactComponent };